import Config from '@skin_config';
import { getAuthData } from '@common/helpers/auth';
import { broadcast, broadcastChannels } from '@common/helpers/broadcast';
import { hasIgorSignature } from './secure';
import { getBMSBanners } from '../services/bmsApi';
import { BannerContentPositionEnum } from '../constants/enums/banners';

export const getBannerImageUrl = (link) => link && !link.startsWith('http://') && !link.startsWith('https://')
    ? `${Config.bms.apiUrl}/${link}`
    : link;

export const getIsBannerVideo = (link) => /\.(mp4|webm|ogg|mov|avi|mkv|flv|wmv|m4v)$/i.test(link || '');

export const getBannerContentPositionName = (iconPosition, hasText) => {
  switch (iconPosition) {
    case BannerContentPositionEnum.Right:  return 'right';
    case BannerContentPositionEnum.Top:    return 'top';
    case BannerContentPositionEnum.Bottom: return 'bottom';
    case BannerContentPositionEnum.Left:
    case BannerContentPositionEnum.None:
    case BannerContentPositionEnum.Center:
    default:
      return hasText ? 'left' : 'center';
  }
};

export const getBannerList = (list, lang) => {
    const perLangList = list.filter(item => item.language === lang);

    if (perLangList.length) return perLangList;

    return list.filter(item => item.language === 'eng');
};

export const getActiveBannersRemote = async () => {
    const { pid } = getAuthData();

    const result = await getBMSBanners(pid);

    return result?.data || null;
}

export const getActiveBannersTerminal = async () => new Promise((resolve) => {
    broadcast.addEventListener(broadcastChannels.BMSContentsReceived, (event) => {
        const contents = event.detail;
        resolve(contents?.Banners);
    }, { once: true });
});

export const getActiveBanners = (() => {
    let cachedValue = null;

    return async () => {
        if (cachedValue) return cachedValue;

        if (!hasIgorSignature()) {
            cachedValue = await getActiveBannersRemote();
            return cachedValue;
        }

        return new Promise((resolve) => {
            let resolved = false;

            getActiveBannersTerminal().then(async (content) => {
                resolved = true;
                cachedValue = content || await getActiveBannersRemote();

                resolve(cachedValue);
            });

            setTimeout(async () => {
                if (!resolved) {
                    cachedValue = await getActiveBannersRemote();
                    resolve(cachedValue);
                }
            }, 5000);
        });
    }
})();